var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "B6BC4D6B-DD31-4617-9BBE-7BD0BF193FD6") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Manager-|-My-Account-Dropdown",
    transform: "translate(-1673.000000, -87.000000)",
    fill: "#023B93",
    stroke: "#023B93",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1652.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(22.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.9,8.06 C3.11,8.23 0,10.85 0,14.23 C0,14.46 0.19,14.65 0.43,14.65 L14.04,14.65 C14.27,14.65 14.46,14.46 14.46,14.23 C13.64,10.94 11.96,8.28 6.9,8.06 L6.9,8.06 Z M7.16,8.82 L7.16,8.82 C7.19,8.82 7.21,8.82 7.23,8.82 C10.59,8.82 13.11,11.08 13.4,13.81 L1.05,13.81 C1.35,11.09 3.83,8.85 7.16,8.82 L7.16,8.82 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23,0 C5.41,0 3.93,1.5 3.93,3.34 C3.93,5.18 5.41,6.69 7.23,6.69 C9.05,6.69 10.54,5.18 10.54,3.34 C10.54,1.5 9.06,0 7.23,0 Z M7.23,0.85 C8.59,0.85 9.69,1.96 9.69,3.34 C9.69,4.73 8.59,5.83 7.23,5.83 C5.87,5.83 4.77,4.72 4.77,3.34 C4.78,1.96 5.88,0.85 7.23,0.85 L7.23,0.85 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.dbb148acba0c4f541215fec9e935478d.svg";
export { ForwardRef as ReactComponent };